import Script from 'next/script';
import { useEffect } from 'react';

const Trackdesk = () => {
  useEffect(() => {
    // Initialize Trackdesk
    window.trackdesk =
      window.trackdesk ||
      function () {
        (window.trackdesk.q = window.trackdesk.q || []).push(arguments);
      };
    window.trackdesk.l = +new Date();

    // Execute Trackdesk tracking
    window.trackdesk(`${process.env.NEXT_PUBLIC_AFFILIATE_ID}`, 'click');
  }, [process.env.NEXT_PUBLIC_AFFILIATE_ID]);

  return (
    <>
      <Script
        async
        src="//cdn.trackdesk.com/tracking.js"
        strategy="afterInteractive"
      />
    </>
  );
};

export default Trackdesk;
